import { render, staticRenderFns } from "./expensemodal.vue?vue&type=template&id=c80bf648"
import script from "./expensemodal.vue?vue&type=script&lang=js"
export * from "./expensemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports